// @flow
import React, { type Node } from 'react';

import styles from './Painted.scss';


type Props = {
  children: string,
  paint: string,
}

const Painted = ({ children, paint }: Props): Node => {
  return (
    <span className={styles[paint]}>
      {children}
    </span>
  );
};

export default Painted;
